<template>
<div id="newsletter-type-subscriber">

  <h3>Newsletter Subscribers</h3>

  <hr />

  <newsletter-type-nav
    :newsletterTypeId="newsletterTypeId"
    v-if="!hideNav"
  ></newsletter-type-nav>

  <newsletter-type-subscriber-search
    :newsletterTypeId="newsletterTypeId"
  ></newsletter-type-subscriber-search>

  <hr />

  <newsletter-type-subscriber-key></newsletter-type-subscriber-key>

  <pagination
    ref="pagination"
    :pageResponse="pageResponse"
    :pageSize="$root.defaultPageSize"
    :resourceUrl="resourceUrl"
    orderBy="created_at"
    orderType="DESC"
    preserveHistory
  >
    <template
      slot="paged_item"
      slot-scope="item"
    >
      <router-link
        :to="{
          name: 'newsletter_type_subscriber',
          params: { newsletterTypeSubscriberId: item.id }
        }"
        :class="$root.listItemClasses + ' subscriber ' + subscriptionClass(item.status)"
      >
        {{ item.subscriber_email }}
      </router-link>
    </template>
  </pagination>

</div>
</template>

<script>
import Pagination from 'sai-vue-kaminari'

import NewsletterTypeNav from '@/components/NewsletterTypeNav'
import NewsletterTypeSubscriberKey from '@/components/NewsletterTypeSubscriberKey'
import NewsletterTypeSubscriberSearch from '@/components/NewsletterTypeSubscriberSearch'

export default {
  data () {
    return {
      subscribers: [],
      pageResponse: {}
    }
  },

  computed: {
    resourceUrl () {
      return this.apiUrl('/newsletter_types/' + this.newsletterTypeId + '/subscribers', true)
    }
  },

  components: {
    'newsletter-type-nav': NewsletterTypeNav,
    'newsletter-type-subscriber-key': NewsletterTypeSubscriberKey,
    'newsletter-type-subscriber-search': NewsletterTypeSubscriberSearch,
    'pagination': Pagination
  },

  props: {
    hideNav: {
      type: Boolean,
      default: false
    },

    newsletterTypeId: {
      type: [Number, String],
      default: undefined,
      required: true
    },

    newsletterTypeSubscriberId: {
      type: [Number, String],
      default: undefined
    }
  },

  created () {
    this.$on('searchComplete', this.onPageSuccess)
  },

  methods: {
    onPageSuccess (resp) {
      this.pageResponse = resp
    },

    subscriptionClass (status) {
      let className = 'success'
      if (status === 'pending') {
        className = 'warning'
      } else if (status === 'unsubscribed') {
        className = 'danger'
      }

      return 'list-group-item-' + className
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/NewsletterTypeSubscribers.vue